import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { TopCard } from '../../constants/patient-curves.constants';
import { AgPatientDriverTopCardComponent } from '../ag-patient-driver-top-card/ag-patient-driver-top-card.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AgPatientDriverTopCardComponent, CommonModule],
  selector: 'aux-ag-patient-driver-upper-cards',
  styles: [],
  templateUrl: './ag-patient-driver-upper-cards-component.html',
})
export class AgPatientDriverUpperCardsComponent {
  @Input() topCards: Observable<TopCard[]> | undefined;
}
